import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import { DEFAULT_TRIGGER_ICON_PROPS, triggerButtonClasses } from "./ContextMenu.styles";

import { Icon } from "../Icon";
import { MenuItems } from "./MenuItems";
import { useState } from "react";
import { ContextMenuAlignAlignment, ContextMenuContentProps, ContextMenuSideAlignment } from "./ContextMenu.types";

export const ContextMenuContent = ({
  menuItems,
  trigger,
  triggerClassName,
  triggerIconProps = DEFAULT_TRIGGER_ICON_PROPS,
  triggerTestId,
  contentTestId,
  side = ContextMenuSideAlignment.BOTTOM,
  sideOffset = 5,
  align = ContextMenuAlignAlignment.END,
  alignOffset = 0,
  disabled = false,
  onOpenChange,
  noBorder = false,
}: ContextMenuContentProps) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  return (
    <DropdownMenu.Root
      open={open}
      onOpenChange={(opn) => {
        const result = onOpenChange?.(opn) as boolean | void | undefined;
        // If onOpenChange returns false, prevent the state change
        if (result === false) {
          return;
        }
        setOpen(opn);
      }}
    >
      {trigger ? (
        <DropdownMenu.Trigger asChild className={triggerClassName} data-testid={triggerTestId} disabled={disabled}>
          {trigger}
        </DropdownMenu.Trigger>
      ) : (
        <DropdownMenu.Trigger
          className={triggerButtonClasses(triggerClassName, open)}
          data-testid={triggerTestId}
          disabled={disabled}
          onClick={(e) => e.stopPropagation()}
        >
          <Icon {...triggerIconProps} />
        </DropdownMenu.Trigger>
      )}

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          side={side}
          sideOffset={sideOffset}
          align={align}
          alignOffset={alignOffset}
          className="z-50 flex flex-col py-1 overflow-hidden bg-white border rounded-lg shadow-md w-60 border-blue-grey-200"
          data-testid={contentTestId}
        >
          <MenuItems items={menuItems} noBorder={noBorder} onClose={handleClose} />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
